
<template>
    <v-container fluid>
        <v-btn v-if="is_mobile" 
            @click="toggleViewOnMobile"
        >
            {{buttonLabel}}
        </v-btn>
        <PDFViewer class="pdf-document--custom pdf-document--custom2" v-bind="{ url: screen_data.document_url }"
            v-if="screen_data.document_url && (!is_mobile || mobile_view == 'document') && !excelType" not_invoice
            :folder_route="screen_data.folderRoute" >
        </PDFViewer>
        <ExcelLinesVisualizer
              v-if="excelType"
              :items="screen_data.document.text_tagging"
              style="margin-top: 48px; width: 100%;"
            />
        
         <!-- Bottom Drawer (Fixed at Bottom) -->

        <v-navigation-drawer v-if="!is_mobile"
            class="drawer drawer--custom"
            app
            right
            clipped
            mobile-breakpoint="0" 
            width="800"
        >
            <OtherDocWorkflowDetail 
                v-if="other_doc_detail_component"
                :screen_data="screen_data"
                :list_component="list_component"
                :other_document_id="other_document_id"
                :companydb_id="companydb_id"
                :other_doc_detail_component="other_doc_detail_component"
            />
        </v-navigation-drawer>
        <span v-else-if="is_mobile && mobile_view != 'document' && other_doc_detail_component">
            <OtherDocWorkflowDetail 
                :screen_data="screen_data"
                :list_component="list_component"
                :other_document_id="other_document_id"
                :companydb_id="companydb_id"
                :other_doc_detail_component="other_doc_detail_component"
            />
        </span>
    </v-container>
    
</template>

<script>
import { VueOtherDocumentScreenData } from '@/modules/document/infra/VueOtherDocumentScreenData';
import PDFViewer from '../components/PDFViewer.vue'
import { mapGetters, mapState } from "vuex";
import {OtherDocDetailComponent} from '../modules/document/application/OtherDocDetailComponent'
import {ApiOtherDocumentRepository} from '../modules/document/infra/ApiOtherDocumentRepository'
import GeneralWorkflowDetail from '@/modules/document/infra/GeneralWorkflowDetail.vue'
import ExtractedDataComponent from '@/modules/document/infra/ExtractedDataComponent.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { document_components_factory } from "@/api/client";
import OtherDocWorkflowDetail from  "@/views/OtherDocWorkflowDetail.vue"
import ExcelLinesVisualizer from '@/components/ExcelLinesVisualizer.vue'

export default {
    name: 'OtherDocDetail',
    components: {
        PDFViewer,
        OtherDocWorkflowDetail,
        ExcelLinesVisualizer
    },
    data() {
        const screen_data = new VueOtherDocumentScreenData()
        const list_component = document_components_factory.get_list_component()
        return {
            screen_data: screen_data,
            other_doc_detail_component:null,
            bottomSheet: false,
            list_component: list_component,
            staff_mode: false,
            mobile_view: "document",
        }
    },
    
    props:{
        other_document_id:{
            type: [Number,String],
            required: true,
            default: null
        },
        companydb_id:{
            type: [Number,String],
            required: false,
            default: null
        }
    },
    async mounted() {
        this.other_doc_detail_component = new OtherDocDetailComponent(new ApiOtherDocumentRepository(), this.screen_data)
        await this.other_doc_detail_component.get_document_url(this.other_document_id)
        await this.other_doc_detail_component.find_by_id(this.other_document_id)
        this.other_doc_detail_component.auto_refresh_untill_stable(this.other_document_id)
        if (this.companydb_id) {
            await this.other_doc_detail_component.getCompanyFolders(this.companydb_id)
            this.screen_data.folderRoute = this.other_doc_detail_component.buildFolderRoute()
        }
    },
    beforeDestroy() {
        this.other_doc_detail_component.force_stop_auto_refresh()
    },
    methods: {
        toggleViewOnMobile() { // swap values "document" and "detail"
            this.mobile_view = this.mobile_view == "document" ? "detail" : "document"
        }
    },
    computed: {
        ...mapGetters([
            "is_mobile",
        ]),
        ...mapGetters({
            userData: 'me/userData',
        }),
        buttonLabel(){
            return this.mobile_view == "document" ? "Ver detalle" : "Ver documento"
        },
        excelType(){
            if( this.screen_data && this.screen_data.document && this.screen_data.document.original_file_name){
                const fileName = this.screen_data.document.original_file_name;
                const extension = fileName.split('.').pop().toLowerCase();
                let right_ext = false
                if (['xls', 'xlsx', 'xlsm', 'ods'].includes(extension)) {
                    right_ext = true;
                } 
                let have_lines = false
                const tt = this.screen_data.document.text_tagging
                if ( tt && Array.isArray(tt) && tt.length > 0 && Array.isArray(tt[0])){
                    have_lines = true
                }
                return right_ext && have_lines

            }
        }
    },
}

</script>


<style scoped>
.bottom-drawer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
}

.v-container {
  padding-bottom: 80px; /* Adjust based on the height of the drawer */
}
</style>

<style>
.drawer--custom {   
    width: 795px !important;
    margin-top: 0;
    margin-right: 5px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.pdf-document--custom {
  width: 100% !important;
}

.pdf-document--custom2 {
  width: 100% !important;
}

.wrapper-pdf-document {
  width: 99% !important;
}
</style>